import { useSnackbar as useNotistack, } from 'notistack';
import { useMemo } from 'react';
export function useSnackbar() {
    const { enqueueSnackbar, closeSnackbar } = useNotistack();
    const creators = useMemo(() => ({
        close: closeSnackbar,
        flashError: createFlash(enqueueSnackbar, 'error'),
        flashInfo: createFlash(enqueueSnackbar, 'info'),
        flashLoading: createFlash(enqueueSnackbar, 'default'),
        flashSuccess: createFlash(enqueueSnackbar, 'success'),
        flashWarning: createFlash(enqueueSnackbar, 'warning'),
        stickError: createSticker(enqueueSnackbar, 'error'),
        stickInfo: createSticker(enqueueSnackbar, 'info'),
        stickLoading: createSticker(enqueueSnackbar, 'default'),
        stickSuccess: createSticker(enqueueSnackbar, 'success'),
        stickWarning: createSticker(enqueueSnackbar, 'warning'),
    }), [closeSnackbar, enqueueSnackbar]);
    return creators;
}
function createFlash(enqueueSnackbar, variant) {
    return (options) => {
        const { message, ...otherOptions } = options;
        const id = enqueueSnackbar(message, {
            variant,
            ...otherOptions,
        });
        return id;
    };
}
function createSticker(enqueueSnackbar, variant) {
    return (options) => {
        const { message, ...otherOptions } = options;
        const id = enqueueSnackbar(message, {
            persist: true,
            variant,
            ...otherOptions,
        });
        return id;
    };
}
